import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

// Utils

import { currencyTools } from '../../../../../utils/tools/currencyTools';
import { filterTools } from '../../../../../utils/tools/filterTools';
import { internationalizeList } from '../../../../../utils/miscellaneous/internationalizeList';

// Constants

import { INCOME_TYPES } from '../../../../../constants/ssap/hhmTypes/incomeAndExpenceTypes';


const SourceSummary = props => {

    // TODO Waiver for <NULL> as value for income/deduction type is added temporarily
    // TODO until we find the reason why we are getting it in production
    // TODO it is regarding getSourceName

    const {
        buttonContainer: ButtonContainer,
        sources,
        member,
        dropdownSourcesList,
        dropdownFrequencyList,
        index = undefined,
        summaryType
    } = props;

    const getThs = () => {

        const ids = [
            {
                id: 'common.source_type',
                replacements: {
                    sourceType: <FormattedMessage id={summaryType}/>
                },
                customClassName: 'grid-col-4'
            },
            {
                id: 'common.amount',
                customClassName: 'grid-col-2',
                replacements: {}
            },
            {
                id: 'common.frequency',
                customClassName: 'grid-col-2',
                replacements: {}
            },
            {
                id: 'common.non_internationalized_text',
                replacements: {
                    text: <FormattedMessage id = 'common.actions' />,
                },
                customClassName: 'usa-sr-only grid-col-4'
            }
        ];

        return internationalizeList(ids, 'th', { scope: 'col' });
    };

    const getSources = () => {
        return sources
            .reduce(
                (refinedSources, source) => {
                    return filterTools.removeDummyType(source)
                        ? [ ...refinedSources, source ]
                        : [ ...refinedSources, INCOME_TYPES.DUMMY ];
                },
                []
            )
            .map(
                (source, idx) => {
                    if (source === INCOME_TYPES.DUMMY) {
                        return null;
                    }

                    const getSourceName = () => {
                        const sourceOption = dropdownSourcesList.find(is => is.value === source.type);
                        return sourceOption ? sourceOption.text : 'Unknown source';
                    };

                    const key = `${ source.type }_${ idx }`;
                    const sourceFrequency = dropdownFrequencyList.find(fr => fr.value === source.frequency).text;
                    const sourceFormattedAmount = currencyTools.getMoneyFormat(source.amount, true);
                    const sourceResolvedIndex = index ? index : idx;

                    return (
                        <tr
                            className='grid-row'
                            key = { key }
                        >
                            <td className='grid-col-4'>{ getSourceName() }</td>
                            <td className='grid-col-2'>{ sourceFormattedAmount }</td>
                            <td className='grid-col-2'>{ sourceFrequency }</td>
                            <td className='grid-col-4'>
                                <ButtonContainer
                                    customButtonClassName = 'btn-small'
                                    type = 'editButton_secondary'
                                    args = { [ sourceResolvedIndex ] }
                                />
                                <ButtonContainer
                                    customButtonClassName = 'btn-small'
                                    type = 'removeButton'
                                    args = { [ member, sourceResolvedIndex ] }
                                />
                            </td>
                        </tr>
                    );
                }
            );
    };

    return (
        <Fragment>
            <div className = 'gi-table__wrapper gi-table__responsive' >
                <table
                    className = 'usa-table usa-table--borderless gi-table gi-table__borderless'
                >
                    <thead>
                        <tr className='grid-row'>
                            { getThs() }
                        </tr>
                    </thead>
                    <tbody>
                        { getSources() }
                    </tbody>
                </table>
            </div>
        </Fragment>
    );
};

export default SourceSummary;
